import tw from 'twin.macro';
import styled from 'styled-components';

export const ChallengeCardContainer = styled.div`
  ${tw`w-full h-full rounded-xl p-4 flex items-center justify-around`};
`;

// Images section
export const ChallengeCardImageContainer = tw.div`min-w-[88px] h-[108px]`;
export const ChallengeCardImage = tw.img`w-full h-full object-cover rounded-t-[4.25rem] rounded-b-lg`;
export const ChallengeCardImageCoin = tw.img`w-[0.875rem] h-4`;

// Text section
export const ChallengeCardCoin = tw.div`flex items-center gap-2`;

// content section
export const ChallengeCardContent = tw.div`flex flex-col h-full pl-4 py-2 gap-4 items-start justify-around`;
export const ChallengeCardContentTitle = tw.div`w-full h-full flex flex-col`;
export const ChallengeCardContentInfo = tw.div`w-full mt-1 flex items-center justify-start gap-3 text-base align-middle`;
